import { useEffect, useState } from "react";

import { makeStyles } from "tss-react/mui";
import { Add } from "@mui/icons-material";
import { Box, Button, Toolbar, Typography } from "@mui/material";
import Table from "../../components/ProductCategory/CategoryTable";

import { ToastContainer } from "react-toastify";

import _ from "lodash";
import { getAllCategory } from "../../apis/ProductCategory";
import { AddCategoryDrawer } from "../../components/ProductCategory/AddCategoryDrawer";
import { FormDrawer } from "../../components/Form/FormDrawer";
import { ProductCategoryAccordion } from "../../components/Menu/SubmenuItem";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { getMasterCategory } from "../../apis/ProductCategory";

const useStyles = makeStyles()((theme) => ({
	title: {
		flexGrow: 1,
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
}));

export const Category = ({ searchText }) => {
	const { classes } = useStyles();

	const [addOpen, setAddOpen] = useState(false);

	const [rows, setRows] = useState([]);
	const [category, setCategory] = useState();

	const [loading, setLoading] = useState(false);
	const [page] = useState(0);
	const [rowsCount] = useState(10);
	const [, setCount] = useState(0);
	const [isEdit, setIsEdit] = useState(false);
	const [openHierarchyDialog, setOpenHierarchyDialog] = useState(false);
	const [allCategories, setAllCategories] = useState([]);

	useEffect(() => {
		const fetchCategories = async () => {
			const data = await getMasterCategory(1000, 1);
			setAllCategories(data.results);
		};

		fetchCategories();
	}, []);

	useEffect(() => {
		setLoading(true);
		_.debounce(async () => {
			const data = await getAllCategory(rowsCount);
			setRows(data.results);
			console.log(data);
			setCount(data.count);
		}, 500)();
		setLoading(false);
	}, [rowsCount]);

	const reloadTable = async () => {
		const data = await getAllCategory(rowsCount, page + 1);
		setRows(data.results);
	};

	const handleAdd = () => {
		setCategory({ name: "" });
		setAddOpen(true);
		setIsEdit(false);
	};

	const handleEdit = (item) => {
		setIsEdit(true);
		setCategory(item);
		setAddOpen(true);
	};

	return (
		<>
			<Toolbar>
				<Typography className={classes.title} variant="h4">
					Product Categories
				</Typography>

				<Button
					onClick={() => setOpenHierarchyDialog(true)}
					variant="contained"
					color="primary"
					sx={{ mr: 2 }}
				>
					Show Category Hierarchy
				</Button>
				{/* <Typography className={classes.title} variant="h4" noWrap /> */}
				<Button
					onClick={() => handleAdd()}
					startIcon={<Add />}
					variant="contained"
					color="primary"
				>
					Add Category
				</Button>
			</Toolbar>
			<ToastContainer />
			<Box sx={{ px: 5 }}>
				<Table handleEdit={handleEdit} />

				<FormDrawer
					setEditOpen={setAddOpen}
					open={addOpen}
					loading={loading}
				>
					<AddCategoryDrawer
						rows={rows}
						setAddOpen={setAddOpen}
						setRows={setRows}
						category={category}
						setCategory={setCategory}
						edit={isEdit}
						reloadTable={reloadTable}
					/>
				</FormDrawer>
			</Box>
			<Dialog
				open={openHierarchyDialog}
				onClose={() => setOpenHierarchyDialog(false)}
				fullWidth
				maxWidth="md"
			>
				<DialogTitle>Category Hierarchy</DialogTitle>
				<DialogContent>
					<ProductCategoryAccordion
						open={true}
						setOpen={setOpenHierarchyDialog}
						categories={allCategories}
						setCategory={() => { }}
						list={true}
					/>
				</DialogContent>
			</Dialog>
		</>
	);
};
